import React, { Component } from 'react';

//components
import CustomButton from "../../../../generic_components/components/buttons/CustomButton";
import { Dialog } from 'primereact/dialog';
import HtmlTextBlock from "../../../../generic_components/components/text_display/HtmlTextBlock";
import TextBox from "../../../../generic_components/components/input_boxes/TextBox";
import AutoCompleteTextBox from "../../../../generic_components/components/input_boxes/AutoCompleteTextBox";
import {InputTextarea} from 'primereact/inputtextarea';

//generic functions
import {
    cloneObject,
    isEmpty
} from "../../../../functions/generic_functions";

//static routes
import {
    cari_api_country_auto_complete_url
} from "../../../../router/static_routes";

//redux
import { connect } from "react-redux";
import {
    openCariModal,
    closeCariModals,
} from "../../../../redux/actions/indexActions";


//redux mappers
const mapStateToProps = state => {
    return {
        cariModalData: state.cariReducer.cariModalData
    };
};
const mapDispatchToProps = dispatch => {
    return {
        openCariModal: (modal_data) => {
            dispatch(openCariModal(modal_data))
        },
        closeCariModals: (modal_data) => {
            dispatch(closeCariModals(modal_data))
        },
    };
};


class CariModals extends Component {
    state = {  
        mounted: false,
        postData: {
            institution_name: "",
            institution_country: "",
            institution_state: "",
            institution_city: "",
        },
        disabledSaveButton: true,
        note: "",
        original_comments: ""
    }

    constructor(props) {
        super(props);
       
        //action handlers
        this.handleOnHideErrorModal = this.handleOnHideErrorModal.bind(this);

        this.handleOnHideSubmitErrorModal = this.handleOnHideSubmitErrorModal.bind(this);

        this.handleOnSubmitConfirmationModal = this.handleOnSubmitConfirmationModal.bind(this);
        this.handleOnCancelSubmitConfirmationModal = this.handleOnCancelSubmitConfirmationModal.bind(this);
        this.handleOnHideSubmitModal = this.handleOnHideSubmitModal.bind(this);

        this.handleOnCancelConsentContactReferenceModal = this.handleOnCancelConsentContactReferenceModal.bind(this);
        this.handleOnOkConsentContactReferenceModal = this.handleOnOkConsentContactReferenceModal.bind(this);
        this.handleOnHideConsentContactReferenceModal = this.handleOnHideConsentContactReferenceModal.bind(this);

        this.handleOnChangeSetInstitutionState = this.handleOnChangeSetInstitutionState.bind(this);
        this.handleOnSaveAddInstitutionModal = this.handleOnSaveAddInstitutionModal.bind(this);
        this.handleOnCancelAddInstitutionModal = this.handleOnCancelAddInstitutionModal.bind(this);

        this.handleOnChangeSetComments = this.handleOnChangeSetComments.bind(this);
        this.handleOnSaveAddCommentsToDocsUploadedModal = this.handleOnSaveAddCommentsToDocsUploadedModal.bind(this);
        this.handleOnCancelAddCommentsToDocsUploadedModal = this.handleOnCancelAddCommentsToDocsUploadedModal.bind(this);
    }

    //close modal and wipe out modal data
    handleOnHideErrorModal() {
        //call back function on click cancel
        if (!isEmpty(this.props.cariModalData.errorModal.callBackFuncOnOk)) {
            this.props.cariModalData.errorModal.callBackFuncOnOk();
        }
        //close modals
        this.props.closeCariModals();
    }

    //close modal and wipe out modal data
    handleOnHideSubmitErrorModal() {
        //call back function on click cancel
        if (!isEmpty(this.props.cariModalData.submitErrorModal.callBackFuncOnOk)) {
            this.props.cariModalData.submitErrorModal.callBackFuncOnOk();
        }
        //close modals
        this.props.closeCariModals();
    }



    handleOnCancelSubmitConfirmationModal() {
        //call back function on click cancel
        if(!isEmpty(this.props.cariModalData.submitConfirmationModal.callBackFuncOnCancel)) {
            this.props.cariModalData.submitConfirmationModal.callBackFuncOnCancel();
        }
        //close modals
        this.props.closeCariModals();
    }
    handleOnSubmitConfirmationModal() {
        //call back function on click submit
        if(!isEmpty(this.props.cariModalData.submitConfirmationModal.callBackFuncOnOk)) {
            this.props.cariModalData.submitConfirmationModal.callBackFuncOnOk();
        }
        //close modals
        this.props.closeCariModals();
    }
    handleOnHideSubmitModal() {
        //call back function on click cancel
        if(!isEmpty(this.props.cariModalData.submitConfirmationModal.callBackFuncOnCancel)) {
            this.props.cariModalData.submitConfirmationModal.callBackFuncOnCancel();
        }
        //close modals
        this.props.closeCariModals();
    }


    handleOnCancelConsentContactReferenceModal() {
        //call back function on click cancel
        if (!isEmpty(this.props.cariModalData.consentContactReferenceModal.callBackFuncOnCancel)) {
            this.props.cariModalData.consentContactReferenceModal.callBackFuncOnCancel();
        }
        //close modals
        this.props.closeCariModals();
    }
    handleOnOkConsentContactReferenceModal() {
        //call back function on click submit
        if (!isEmpty(this.props.cariModalData.consentContactReferenceModal.callBackFuncOnOk)) {
            this.props.cariModalData.consentContactReferenceModal.callBackFuncOnOk();
        }
        //close modals
        this.props.closeCariModals();
    }
    handleOnHideConsentContactReferenceModal() {
        //call back function on click cancel
        if (!isEmpty(this.props.cariModalData.addInstitutionModal.callBackFuncOnCancel)) {
            this.props.cariModalData.consentContactReferenceModal.callBackFuncOnCancel();
        }
        //close modals
        this.props.closeCariModals();
    }

    handleOnSaveAddInstitutionModal() {
        //call back function on click save
        if (!isEmpty(this.props.cariModalData.addInstitutionModal.callBackFuncOnOk)) {
            this.props.cariModalData.addInstitutionModal.callBackFuncOnOk(this.state.postData);
        }

        var copyPostData = cloneObject(this.state.postData);

        for (let stateKey in copyPostData) {
            copyPostData[stateKey] = "";
        }

        this.setState({
            postData: copyPostData
        });

        //close modals
        this.props.closeCariModals();
    }

    handleOnCancelAddInstitutionModal() {
        //call back function on click cancel
        if (!isEmpty(this.props.cariModalData.addInstitutionModal.callBackFuncOnCancel)) {
            this.props.cariModalData.addInstitutionModal.callBackFuncOnCancel();
        }
        var copyPostData = cloneObject(this.state.postData);

        for (let stateKey in copyPostData) {
            copyPostData[stateKey] = "";
        }

        this.setState({
            postData: copyPostData
        });

        this.props.closeCariModals();
    }

    handleOnChangeSetInstitutionState(value, nameKey) {
        var copyPostData = this.state.postData;
        copyPostData[nameKey] = value;

        this.setState({
            postData: copyPostData
        });
        
        const rforeign = /[^\u0000-\u007f]/;

        if(value == '') {
            this.setState({
                disabledSaveButton: true
            });
        }
        else if(this.state.postData['institution_name'] == '' || this.state.postData['institution_country'] == ''
                || this.state.postData['institution_state'] == '' || this.state.postData['institution_city'] == '') {
            this.setState({
                disabledSaveButton: true
            });
        }
        else if (rforeign.test(this.state.postData['institution_name']) || rforeign.test(this.state.postData['institution_state']) || rforeign.test(this.state.postData['institution_city'])) {
            this.setState({
                disabledSaveButton: true
            });
        }
        else {
            this.setState({
                disabledSaveButton: false
            });
        }
    }

    handleOnSaveAddCommentsToDocsUploadedModal() {
        //call back function on click save
        if (!isEmpty(this.props.cariModalData.addCommentsToDocsUploadedModal.callBackFuncOnOk)) {
            this.props.cariModalData.addCommentsToDocsUploadedModal.callBackFuncOnOk(this.state.note);
        }

        //close modals
        this.props.closeCariModals();
    }

    handleOnCancelAddCommentsToDocsUploadedModal() {
        //call back function on click cancel
        if (!isEmpty(this.props.cariModalData.addCommentsToDocsUploadedModal.callBackFuncOnCancel)) {
            this.props.cariModalData.addCommentsToDocsUploadedModal.callBackFuncOnCancel();
        }

        var original_comments = this.state.original_comments;
      
        this.setState({
            note: original_comments
        });

        this.props.closeCariModals();
    }

    handleOnChangeSetComments = (event) => {
        var comments = event.target.value;

        this.setState({
            note: comments
        });
    } 


    componentDidMount() {
        this.setState({
            mounted: true
        });
    }

    componentWillUnmount() {
        this.setState({
            mounted: false
        });
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            note: newProps.cariModalData.addCommentsToDocsUploadedModal.note,
            original_comments: newProps.cariModalData.addCommentsToDocsUploadedModal.note,
            // postData: newProps.cariModalData.addInstitutionModal.customInstitutionData
        });
    }

    render()  {
        const autoCompleteUrls = {
            "cari_api_country_auto_complete_url": cari_api_country_auto_complete_url
        }

        const errorModalHeader = (
            <strong className="error_code_color">
                {(!isEmpty(this.props.cariModalData.errorModal.title) ?
                    this.props.cariModalData.errorModal.title
                    : null)
                }
            </strong>
        );

        const errorModalFooter = (
            <div>
                <CustomButton
                    onClickSetParentState={this.handleOnHideErrorModal}
                    btnRaised={true}
                    icon={"check"}
                    iconLocation={"left"}
                    iconSize={"lg"}
                    className={"p-button-info"}
                    label={"Ok"}
                />
            </div>
        );

        const submitErrorModalHeader = (
            <strong className="error_code_color">
                {(!isEmpty(this.props.cariModalData.submitErrorModal.title) ?
                    this.props.cariModalData.submitErrorModal.title
                    : null)
                }
            </strong>
        );

        const submitErrorModalFooter = (
            <div>
                <CustomButton
                    onClickSetParentState={this.handleOnHideSubmitErrorModal}
                    btnRaised={true}
                    icon={"check"}
                    iconLocation={"left"}
                    iconSize={"lg"}
                    className={"p-button-info"}
                    label={"Okay"}
                />
            </div>
        );

        const submitConfirmationModalHeader = (
            <strong className="submit_text">
                {(!isEmpty(this.props.cariModalData.submitConfirmationModal.title) ?
                    this.props.cariModalData.submitConfirmationModal.title
                    : null)
                }
            </strong>
        );

        const submitConfirmationModalFooter = (
            <div>
                <CustomButton
                    onClickSetParentState={this.handleOnCancelSubmitConfirmationModal}
                    btnRaised={true}
                    icon={"times"}
                    iconLocation={"left"}
                    iconSize={"lg"}
                    className={"p-button-danger"}
                    label={"Cancel"}
                />
                <CustomButton
                    onClickSetParentState={this.handleOnSubmitConfirmationModal}
                    btnRaised={true}
                    icon={"check"}
                    iconLocation={"left"}
                    iconSize={"lg"}
                    className={"p-button-success"}
                    label={"Submit"}
                />
            </div>
        );

        const addInstitutionModalHeader = (
            <strong>
                {(!isEmpty(this.props.cariModalData.addInstitutionModal.title) ?
                    this.props.cariModalData.addInstitutionModal.title
                    : null)
                }
            </strong>
        );

        const addInstitutionModalFooter = (
            <div className="addInstitutionModalFooter_style">
                <CustomButton
                    onClickSetParentState={this.handleOnCancelAddInstitutionModal}
                    btnRaised={true}
                    icon={"times"}
                    iconLocation={"left"}
                    iconSize={"lg"}
                    className={"p-button-sfu-red"}
                    label={"Cancel"}
                />
                <CustomButton
                    onClickSetParentState={this.handleOnSaveAddInstitutionModal}
                    btnRaised={true}
                    icon={"check"}
                    iconLocation={"left"}
                    iconSize={"lg"}
                    className={"p-button-text save_institution_btn_format"}
                    label={"Save"}
                    disabled={this.state.disabledSaveButton}
                />
            </div>
        );

        const addCommentsToDocsUploadedModalHeader = (
            <strong>
                {(!isEmpty(this.props.cariModalData.addCommentsToDocsUploadedModal.title) ?
                    this.props.cariModalData.addCommentsToDocsUploadedModal.title
                    : null)
                }
            </strong>
        );

        const addCommentsToDocsUploadedModalFooter = (
            <div>
                <CustomButton
                    onClickSetParentState={this.handleOnCancelAddCommentsToDocsUploadedModal}
                    btnRaised={true}
                    icon={"times"}
                    iconLocation={"left"}
                    iconSize={"lg"}
                    className={"p-button-sfu-red"}
                    label={"Cancel"}
                />
                <CustomButton
                    onClickSetParentState={this.handleOnSaveAddCommentsToDocsUploadedModal}
                    btnRaised={true}
                    icon={"check"}
                    iconLocation={"left"}
                    iconSize={"lg"}
                    className={"p-button-text save_institution_btn_format"}
                    label={"Save"}
                    // disabled={this.state.disabledSaveButton}
                />
            </div>
        );

        const consentContactReferenceModalHeader = (
            <strong>
                {(!isEmpty(this.props.cariModalData.consentContactReferenceModal.title) ?
                    this.props.cariModalData.consentContactReferenceModal.title
                    : null)
                }
            </strong>
        );

        const consentContactReferenceModalFooter = (
            <div>
                <CustomButton
                    onClickSetParentState={this.handleOnCancelConsentContactReferenceModal}
                    btnRaised={true}
                    className={"p-button-danger"}
                    textOnly={true}
                    label={"No"}
                />
                <CustomButton
                    onClickSetParentState={this.handleOnOkConsentContactReferenceModal}
                    btnRaised={true}
                    className={"p-button-success"}
                    textOnly={true}
                    label={"Yes"}
                />
            </div>
        );
    
        return (
            <div>
                {(this.state.mounted) ?
                    <div>
                        <Dialog
                            header={errorModalHeader}
                            visible={this.props.cariModalData.errorModal.visible}
                            width="400px"
                            modal={true}
                            onHide={this.handleOnHideErrorModal}
                            footer={errorModalFooter}
                            draggable={false}
                            baseZIndex={10000}
                        >
                            {(!isEmpty(this.props.cariModalData.errorModal.contentText) ?
                                this.props.cariModalData.errorModal.contentText
                                : null
                            )
                            }
                        </Dialog>
                        <Dialog
                            header={submitErrorModalHeader}
                            visible={this.props.cariModalData.submitErrorModal.visible}
                            width="600px"
                            modal={true}
                            onHide={this.handleOnHideSubmitErrorModal}
                            footer={submitErrorModalFooter}
                            draggable={false}
                            baseZIndex={10000}
                        >
                            {(!isEmpty(this.props.cariModalData.submitErrorModal.contentText) ?
                                    <HtmlTextBlock
                                        text={this.props.cariModalData.submitErrorModal.contentText}
                                    />
                                : null)
                            }
                        </Dialog>

                        <Dialog
                            header={submitConfirmationModalHeader}
                            visible={this.props.cariModalData.submitConfirmationModal.visible}
                            width="800px"
                            modal={true}
                            onHide={this.handleOnHideSubmitModal}
                            footer={submitConfirmationModalFooter}
                            draggable={false}
                            baseZIndex={10000}
                        >
                            {(!isEmpty(this.props.cariModalData.submitConfirmationModal.contentData) 
                            && !isEmpty(this.props.cariModalData.submitConfirmationModal.contentData.referencesForConsent) 
                            && (!isEmpty(this.props.cariModalData.submitConfirmationModal.contentData.referencesForConsentText) 
                            && this.props.cariModalData.submitConfirmationModal.contentData.referencesForConsent.length > 0)) ?
                                <React.Fragment>
                                    <HtmlTextBlock
                                        text={this.props.cariModalData.submitConfirmationModal.contentData.referencesForConsentText}
                                        className={"cari_small_text"}
                                    />

                                    <ul className={"cari_small_text"}>          
                                        {this.props.cariModalData.submitConfirmationModal.contentData.referencesForConsent.map(function (reference, i) {
                                            return (
                                                <li key={i}>
                                                    <strong> 
                                                        {reference.first_name} {reference.last_name}
                                                    </strong>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </React.Fragment>
                            : null}
                          
                            <HtmlTextBlock
                                text={(!isEmpty(this.props.cariModalData.submitConfirmationModal.contentText) ?
                                    this.props.cariModalData.submitConfirmationModal.contentText
                                    : ""
                                )}
                                className={"cari_small_text"}
                            />

                        </Dialog>

                        <Dialog
                            header={consentContactReferenceModalHeader}
                            visible={this.props.cariModalData.consentContactReferenceModal.visible}
                            width="800px"
                            modal={true}
                            onHide={this.handleOnHideConsentContactReferenceModal}
                            footer={consentContactReferenceModalFooter}
                            draggable={false}
                            baseZIndex={10000}
                        >
                            <HtmlTextBlock
                                text={(!isEmpty(this.props.cariModalData.consentContactReferenceModal.contentText) ?
                                    this.props.cariModalData.consentContactReferenceModal.contentText
                                    : ""
                                )}
                                className={"cari_small_text"}
                            />
                        </Dialog>

                        <Dialog
                            header={addInstitutionModalHeader}
                            visible={this.props.cariModalData.addInstitutionModal.visible}
                            width="800px"
                            modal={true}
                            onHide={this.handleOnCancelAddInstitutionModal}
                            footer={addInstitutionModalFooter}
                            draggable={false}
                            baseZIndex={10000}
                        >
                            <br/>
                            <HtmlTextBlock
                                text={(!isEmpty(this.props.cariModalData.addInstitutionModal.contentText) ?
                                    this.props.cariModalData.addInstitutionModal.contentText
                                    : ""
                                )}
                                className={"cari_small_text"}
                            />
                            <div className="p-col-12">
                                <br/> <br/>   
                                <div className="">
                                    <div className="p-grid">
                                        <div className="p-col-6 padding-right_style_col">
                                            <label className={"label_style"}>
                                                Institution Name <strong className="sfu_red">*</strong>
                                            </label>
                                        </div>
                                        <div className="p-col-6 padding-left_style_col">
                                            <label className={"label_style"}>
                                                Country <strong className="sfu_red">*</strong>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="p-grid">
                                        <div className="p-col-6 padding-right_style_col">
                                            <TextBox
                                                value={this.state.postData['institution_name']}
                                                name={"institution_name"}
                                                placeholder={"Institution Name"}
                                                onChangeSetParentState={this.handleOnChangeSetInstitutionState}
                                                required={true}
                                                maxLength={255}
                                                disabled={this.props.submitted}
                                                className={(this.props.submitted)? "disabled_input_box_format":"input_box_format"}
                                                latinOnly={true}
                                            />
                                        </div>
                                        <div className="p-col-6 padding-left_style_col">
                                            <AutoCompleteTextBox
                                                value={this.state.postData['institution_country']}
                                                onChangeSetParentState={this.handleOnChangeSetInstitutionState}
                                                placeholder={"Country"}
                                                name={"institution_country"}
                                                minLength={3}
                                                maxLength={80}
                                                autoCompleteUrl={autoCompleteUrls.cari_api_country_auto_complete_url}
                                                required={true}
                                            />
                                        </div>

                                    </div>

                                    <br/>

                                    <div className="p-grid">
                                        <div className="p-col-6 padding-right_style_col">
                                            <label className={"label_style"}>
                                                Province/State <strong className="sfu_red">*</strong>
                                            </label>
                                        </div>
                                        <div className="p-col-6 padding-left_style_col">
                                            <label className={"label_style"}>
                                                City <strong className="sfu_red">*</strong>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="p-grid">
                                        <div className="p-col-6 padding-right_style_col">
                                            <TextBox
                                                value={this.state.postData['institution_state']}
                                                name={"institution_state"}
                                                placeholder={"Select Province/State"}
                                                onChangeSetParentState={this.handleOnChangeSetInstitutionState}
                                                maxLength={100}
                                                className={(this.props.submitted)? "disabled_input_box_format":"input_box_format"}
                                                required={true}
                                                latinOnly={true}
                                            />
                                        </div>
                                        <div className="p-col-6 padding-left_style_col">
                                            <TextBox
                                                value={this.state.postData['institution_city']}
                                                name={"institution_city"}
                                                placeholder={"City"}
                                                onChangeSetParentState={this.handleOnChangeSetInstitutionState}
                                                maxLength={200}
                                                className={(this.props.submitted)? "disabled_input_box_format":"float_right_input_box_format"}
                                                required={true}
                                                latinOnly={true}
                                           />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Dialog>

                        <Dialog
                            header={addCommentsToDocsUploadedModalHeader}
                            visible={this.props.cariModalData.addCommentsToDocsUploadedModal.visible}
                            width="800px"
                            modal={true}
                            onHide={this.handleOnCancelAddCommentsToDocsUploadedModal}
                            footer={addCommentsToDocsUploadedModalFooter}
                            draggable={false}
                            baseZIndex={10000}
                        >
                            <HtmlTextBlock
                                text={(!isEmpty(this.props.cariModalData.addCommentsToDocsUploadedModal.contentText) ?
                                    this.props.cariModalData.addCommentsToDocsUploadedModal.contentText
                                    : ""
                                )}
                                className={"cari_small_text"}
                            />

                            <div className="p-col-12">
                                <br/>
                                <div className="p-grid">
                                    <InputTextarea
                                        value={!isEmpty(this.state.note) ? this.state.note : ""}
                                        name={"note"}
                                        onChange={(event) => {
                                            this.handleOnChangeSetComments(event)
                                        }}
                                        autoResize={true}
                                        className={"comments_textarea_style"}
                                        maxLength="200"
                                    />
                                </div>
                            </div>
                             
                        </Dialog>

                    </div>
                : null}
            </div>
         );
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(CariModals);